import '../less/style.less';
import "bootstrap/dist/js/bootstrap.min.js";
import commons from './commons';

$(document).ready(function () {
    commons.setMenuMobile();
    commons.setVerticalMenu();
    commons.setFullBg();
    commons.setTabs();
    commons.setFooterMenu();
    commons.preventDownloadBtn();
    commons.setContactForm();
    commons.setBtnEmail();


});




// WEBPACK FOOTER //
// ./src/js/index.js